// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"213":"af3f5db4","533":"ca529f8f"}[chunkId] + ".chunk.css";
};